import * as types from '../types/blogTypes';
import * as blogServices from '../../services/blogServices';

export const fetchBlogPosts = (params = {}) => async (dispatch) => {
  dispatch({ type: types.FETCH_BLOG_LIST_REQUEST });
  try {
    const response = await blogServices.getBlogPosts(params);
    dispatch({ type: types.FETCH_BLOG_LIST_SUCCESS, payload: response });
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to fetch blog posts';
    dispatch({ type: types.FETCH_BLOG_LIST_FAILURE, payload: message });
  }
};

export const fetchBlogPostBySlug = (slug) => async (dispatch) => {
  dispatch({ type: types.FETCH_BLOG_ITEM_REQUEST });
  try {
    const response = await blogServices.getBlogPostBySlug(slug);
    dispatch({ type: types.FETCH_BLOG_ITEM_SUCCESS, payload: response });
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'Failed to fetch blog post';
    dispatch({ type: types.FETCH_BLOG_ITEM_FAILURE, payload: message });
  }
};

export const clearBlogPost = () => ({ type: types.CLEAR_BLOG_ITEM });

